export default __webpack_public_path__ + "static/ArtboardU-3dba712b8bb4117c98273cfc0476884a.png";